import "./labelItem.less";

const LabelItem = ({ value, title, showTitle }) => {
   if (title === "-" || title === null || title === "") return null;

   return (
      <div className="gx-product-body-label">
         <p className="p3">
            {showTitle === true && <b>{title}: </b>}
            {value !== null && value !== undefined && value !== "" ? value : "-"}
         </p>
      </div>
   );
};

export default LabelItem;
